



































































import { NodeView } from 'rete/types/view/node'
import Vue from 'vue'
import { Component, Prop, Watch } from "vue-property-decorator"

import { CustomConnection } from '../../logic/Connections/CustomConnection'
import CustomEditor from '../../logic/Editor/CustomEditor'
import { CustomNode } from '../../logic/Nodes'
import { SocketNames } from '../index'
import { SELF_NODE_ITEM } from './SocketsHelper'

@Component({
  name: 'FakeSocket',
  data() {
    return {
      SocketNames,
      CustomNode,
      SELF_NODE_ITEM
    }
  }
})
export default class FakeSocket extends Vue {
  @Prop() editor!: CustomEditor

  @Prop() connections!: Array<CustomConnection>

  @Prop() socketName!: SocketNames

  currentId: null | number = null

  isOpen = false

  @Watch('isOpen')
  isOpenWatcher(state: boolean): void {
    if (state) {
      this.selectFirstSocketIfExists()
    }
  }

  get fakeSocketsStyles(): Record<string, string> {
    switch (this.socketName) {
      case SocketNames.StartOutput:
        return { left: 'calc(100% + 35px)', top: '50%', transform: 'translateY(-50%)' }
      case SocketNames.MainInput:
        return { right: 'calc(100% + 30px)' }
      default:
        return { left: 'calc(100% + 50px)' }
    }
  }

  get ids(): Array<number> {
    return this.connections.map(({ data }) => data.id)
  }

  selectFirstSocketIfExists() {
    if (this.connections.length) {
      this.currentId = this.connections[0].data.id
    } else {
      this.isOpen = false
    }
  }

  show(): void {
    const connection = this.connections.find(({ data }) => data.id === this.currentId)

    if (connection) {
      this.editor.toggleConnectionVisibilityHandler(connection)

      this.$nextTick(() => {
        this.selectFirstSocketIfExists()
      })
    }
  }

  remove(): void {
    const connection = this.connections.find((c) => c.data.id === this.currentId)

    if (connection) {
      this.editor.removeConnection(connection)

      this.$nextTick(() => {
        this.selectFirstSocketIfExists()
      })
    }
  }

  goToOtherEnd(): void {
    const arg = this.socketName === SocketNames.MainInput ? 'output' : 'input'

    this.editor.view.connections.forEach((key, value) => {
      const connection = value as CustomConnection

      if (connection.data.id === this.currentId) {
        const node = arg === 'output' ? connection.output.node : connection.input.node
        const nodeView = this.editor.view.nodes.get(node)

        if (node && nodeView) {
          this.translateToSocket(node, nodeView, arg, connection)
        }
      }
    })
  }

  translateToSocket(node: CustomNode, nodeView: NodeView, arg: 'input' | 'output', connection: CustomConnection): void {
    const k = this.editor.view.area.transform.k
    const [ x, y ] = node.position
    const socket = nodeView.sockets.get(arg === 'output' ? connection.output : connection.input)

    if (socket) {
      const socketEl = socket.el

      const socketCenterX = (x + socketEl.offsetLeft + socketEl.clientWidth / 2) * k
      const socketCenterY = (y + socketEl.offsetTop + socketEl.clientHeight / 2) * k

      const areaX = this.editor.view.area.container.clientWidth / 2
      const areaY = this.editor.view.area.container.clientHeight / 2

      this.editor.view.area.translate((socketCenterX - areaX) * -1, (socketCenterY - areaY) * -1)
      this.isOpen = false
    }
  }
}
